/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TransactionStatus {
    SUCCESS = 'success',
    REFUNDED = 'refunded',
    PARTIALLY_REFUNDED = 'partially_refunded',
    DISPUTED = 'disputed',
    FAILED = 'failed',
    PENDING = 'pending',
}
